import { Pipe, PipeTransform } from '@angular/core';
import { Multilingual } from '@digilize/shared/definitions/src';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'getTranslation',
  // Impure so the text follows a language switch.
  pure: false,
  standalone: false,
})
export class GetTranslationPipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {}

  transform(multi: Multilingual | undefined, errorCb?: (text: string) => void): string {
    const text = multi[this.translocoService.getActiveLang() as keyof Multilingual];

    if (!text) {
      /*  console.error('Wrong Multilingual object, provided:', multi); */
      return '';
    }
    if (errorCb) {
      errorCb(text);
    }
    return text;
  }
}
